import { SHORTLIST_HOR_ID_REGEXP } from '@/constants/email'

type ParseHorIdFromHtmlResult = {
  id?: number
  wasFound: boolean
  reason?: string | null
}

export const parseHorIdFromHtml = (html: string): ParseHorIdFromHtmlResult => {
  const regex = SHORTLIST_HOR_ID_REGEXP

  const r = RegExp(regex)
  const m = r.exec(html)

  if (!m || m.length < 2) {
    return { id: 0, wasFound: false }
  }

  const id = parseInt(m[1], 10)

  return { id, wasFound: true }
}
